import React from 'react';
import NowLoadingMessage from '@src/components/NowLoadingMessage/NowLoadingMessage';

const SchedulePane = React.lazy(() => import('@views/dashboard/production/OrderOperationsList/schedule/SchedulePane'));
const ListOfOperations = React.lazy(() => import('@views/dashboard/production/OrderOperationsList/list-of-operations/ListOfOperations'));

export default function Body(props: { hideSchedule?: boolean }) {
    const transPrefix = 'Dashboards:Production.order-operations-list';

    return <React.Suspense fallback={<NowLoadingMessage/>}>
        {props.hideSchedule === true ? null : (
                <div className="mb-5">
                    <SchedulePane transPrefix={`${transPrefix}.schedule`}/>
                </div>
        )}

        <ListOfOperations transPrefix={`${transPrefix}.list`}/>
    </React.Suspense>;
}
